import React, { forwardRef } from 'react';
import { Picture } from 'app/components/Picture';
import { Video } from 'app/components/Video';
import {
    getS3ObjectUrl,
    getStaticImageSource,
    getDynamicImageSource,
} from 'app/libs/url';
import { productImageGalleryTypeKey } from './define';
import { type ProductImageGalleryProps, type SlideOptions } from './ProductImageGallery';
import STYLE from './ProductImageGallery.module.scss';

const DefaultSlide = (props: SlideOptions) => {
    const { slideOptions } = props;

    return Array(10)
        .fill(null)
        .map((_, idx) => {
            const source = getStaticImageSource(
                getS3ObjectUrl(
                    `/static/image-gallery/image-gallery-presentation-${idx + 1}.png`
                )
            );

            return (
                <li
                    key={`${slideOptions.type}-${idx}/10`}
                    className={STYLE.imageGalleryPresentationItem}
                >
                    <Picture
                        sources={[{ ...source }]}
                        alt={`Product Image - ${idx + 1}`}
                    />
                </li>
            );
        });
};

export const Wall = forwardRef<HTMLUListElement, ProductImageGalleryProps & SlideOptions>(
    (props, ref) => {
        const { slideOptions, isBuyer } = props;

        const presentationClassNameMap = {
            [productImageGalleryTypeKey.wall]: STYLE.wallStyle,
            [productImageGalleryTypeKey.wall2]: STYLE.wallStyle2,
        };

        return (
            <ul ref={ref} className={presentationClassNameMap[slideOptions.type]}>
                {isBuyer &&
                    slideOptions.medias.map((media, idx) => {
                        const source = getDynamicImageSource(media.src);

                        return (
                            <li
                                key={`${slideOptions.type}-${idx}/${slideOptions.medias.length}`}
                                className={STYLE.imageGalleryPresentationItem}
                            >
                                {source.type.startsWith('image') && (
                                    <Picture
                                        defaultSrc={source.src}
                                        sources={[
                                            {
                                                srcSet: source.srcSet,
                                                type: source.type,
                                            },
                                        ]}
                                        alt={`Product Image - ${idx + 1}`}
                                    />
                                )}
                                {source.type.startsWith('video') && (
                                    <Video src={source.src} />
                                )}
                            </li>
                        );
                    })}
                {!isBuyer && <DefaultSlide slideOptions={slideOptions} />}
            </ul>
        );
    }
);

Wall.displayName = 'ImageWall';
